import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IMedicalExamCertificateDecisionType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class MedicalExamCertificateDecisionType implements IMedicalExamCertificateDecisionType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    get Qualified_NonExceptedInterstate(): IMedicalExamCertificateDecisionType {
        return this.FromId(1);
    }

    get Qualified_StateVariances(): IMedicalExamCertificateDecisionType {
        return this.FromId(2);
    }

    get MedicallyUnqualified(): IMedicalExamCertificateDecisionType {
        return this.FromId(3);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, active: true, value: 'QualifiedNonExceptedInterstate', displayValue: 'Qualified - Non Excepted Interstate', description: 'Qualified - Non Excepted Interstate', sotOrder: 99999 });
        this._dictionary.add('2', { id: 2, active: true, value: 'QualifiedStateVariances', displayValue: 'Qualified - State Variances', description: 'Qualified - State Variances', sotOrder: 99999 });
        this._dictionary.add('3', { id: 3, active: true, value: 'MedicallyUnqualified', displayValue: 'Medically Unqualified', description: 'Medically Unqualified', sotOrder: 99999 });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IMedicalExamCertificateDecisionType {
        return this._dictionary[id];
    }

    public FromValue = (value: string): IMedicalExamCertificateDecisionType => {
        var match = this._dictionary.getValues().filter(data =>  data.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    };

    public GetAll = (): IMedicalExamCertificateDecisionType[] => this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));

    public GetActive = (): IMedicalExamCertificateDecisionType[] => this.GetAll().filter(data => data.active);

    public Sort = (primaryField, secondaryField, reverse): IMedicalExamCertificateDecisionType[] => this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));

    private sort_by = function(path, reverse, primer, then) {
        var get = function(obj, path) {
                if (path) {
                    path = path.split('.');
                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }
                    return obj[path[len]];
                }
                return obj;
            },
            prime = function(obj) {
                return primer ? primer(get(obj, path)) : get(obj, path);
            };

        return function(a, b) {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
